/**
 * LVS reference cap heights (mm) — h ∈ {100..400} on a 50 mm step.
 *
 * Single source consumed by every input that picks a row height: foni
 * row editor, arrow controls, future inspector pages.
 */
export const LVS_H_OPTIONS = [100, 150, 200, 250, 300, 350, 400] as const

export type LvsH = (typeof LVS_H_OPTIONS)[number]
